<button
  [type]="nativeType()"
  class="button {{ buttonSizeMap[size()] }} {{ buttonTypeMap[type()] }}"
  [class.button--icon]="isIconButton()"
  [class.button--no-padding]="noPadding()"
  [disabled]="disabled()"
>
  <span class="button__prefix empty-hidden">
    <ng-content select="[prefix-icon]"></ng-content>
  </span>
  <span>
    <ng-content></ng-content>
  </span>
  <span class="button__postfix empty-hidden">
    <ng-content select="[postfix-icon]"></ng-content>
  </span>
</button>
